var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"wrapper"},[_c('Aside'),_c('el-container',{attrs:{"direction":"vertical"}},[_c('Header'),_c('div',{staticClass:"main"},[_c('router-view',{key:_vm.key})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }